import axios from "../../../../../utils/authAxios";

const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/OfficeAppliancesTypeConfig";

export const deleteTypes = async (typeIds: number[]) => {
  await axios.delete(`${api_base_url}/DeactivateType`, {
    data: typeIds,
  });
};
